import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import LabelsContext from "../../../lang/LabelsContext";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import AssociateStatisticsService, { AssociateStatisticsServiceType } from "./AssociateStatisticsService";
import useStyles from "./AssociateStatisticsStyle";

export default function AssociateStatistics() {
  const classes = useStyles();
  const { Labels } = LabelsContext();
  const { associateList }: AssociateStatisticsServiceType = AssociateStatisticsService();

  return (
    <div style={{ zIndex: -1, position: "absolute" }}>
      <CssBaseline />
      <Paper className={classes.paper}>
        <MaterialTable
          icons={tableIcons}
          columns={[
            {
              sorting: true,
              title: Labels.ASSOCIATE_EDITOR,
              render: (rowData: any) => <div>{rowData.firstName + " " + rowData.lastName}</div>,
            },
            { 
              field: "currentAssignments", 
              title: Labels.ACTIVE_ASSIGNMENTS,
              render: (rowData: any) => <div>{rowData.currentAssignments}</div>,
            },
            {
              field: "responseTime",
              title: Labels.RESPONSE_TIME_DAYS,
              render: (rowData: any) => <div>{parseFloat(rowData.responseTime).toFixed(2)}</div>,
            },

            { field: "directReject", title: Labels.DIRECT_REJECT },
            {
              field: "directRejectPct",
              title: Labels.DIRECT_REJECT + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.directRejectPct).toFixed(2)) * 100}</div>,
            },
            { field: "rejected", title: Labels.REJECT },
            {
              field: "rejectedPct",
              title: Labels.REJECT + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.rejectedPct).toFixed(2)) * 100}</div>,
            },
            { field: "rejectedRO", title: Labels.REJECTED_R0 },
            {
              field: "rejectedROPct",
              title: Labels.REJECTED_R0 + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.rejectedROPct).toFixed(2)) * 100}</div>,
            },
            { field: "directRejectRO", title: Labels.DIRECT_REJECT_R0 },
            {
              field: "directRejectROPct",
              title: Labels.DIRECT_REJECT_R0 + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.directRejectROPct).toFixed(2)) * 100}</div>,
            },
            { field: "majorRevision", title: Labels.MAJOR_REVISION },
            {
              field: "majorRevisionPct",
              title: Labels.MAJOR_REVISION + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.majorRevisionPct).toFixed(2)) * 100}</div>,
            },
            { field: "minorRevision", title: Labels.MINOR_REVISION },
            {
              field: "minorRevisionPct",
              title: Labels.MINOR_REVISION + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.minorRevisionPct).toFixed(2)) * 100}</div>,
            },
            { field: "accepted", title: Labels.ACCEPTED },
            {
              field: "acceptedPct",
              title: Labels.ACCEPTED + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.acceptedPct).toFixed(2)) * 100}</div>,
            },
            { field: "letter", title: Labels.LETTER_TO_THE_EDITOR },
            {
              field: "letterPct",
              title: Labels.LETTER_TO_THE_EDITOR + "%",
              render: (rowData: any) => <div>{parseFloat(parseFloat(rowData.letterPct).toFixed(2)) * 100}</div>,
            },
            { field: "decisionsCount", title: "Total decisions" },
          ]}
          title={Labels.ASSOCIATE_STATISTICS}
          data={associateList}
          options={{
            actionsColumnIndex: -1,
            pageSize: 10,
            exportAllData: true,
            exportButton: {
              csv: true,
              pdf: true,
            },
          }}
        />
      </Paper>
    </div>
  );
}
